module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/fdr/fdr.component.css
// module id = ./src/app/fdr/fdr.component.css
// module chunks = main